import React, {useState} from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import {useHover} from '../../../../hooks/useHover';
import {Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {helpPopoverRef} from '../../../../_shared/Help/constants';
import {Headers} from './consts';
import texts from '../../texts';
import {isRTL} from '../../../../Localization';
import {getHelpData} from '../../utils';

interface Props {
    column: Headers;
    index: number;
}

const HeaderItem = ({column, index}: Props) => {
    const {setRef, isHovering} = useHover();
    const [isHelpOpen, setIsHelpOpen] = useState(false);

    const handleShowColumnHelp = (e, data) => {
        e.stopPropagation();
        setIsHelpOpen(true);
        const helpData = getHelpData(data);
        helpPopoverRef.current.showHelpPopover({
            ...helpData,
            anchor: e.target,
            onClose: () => setIsHelpOpen(false)
        });
    };

    return (
        <div
            dir={isRTL() ? 'rtl' : 'ltr'}
            ref={setRef}
            className={cx(styles.tableHeaderItem, {
                [styles.separator]:
                    column.title === texts.fieldsTableSort ||
                    column.title === texts.fieldsTableFormat,
                [styles.required]: column.title === texts.fieldsTableInput
            })}
        >
            <Text skin="paragraph-2" textColor="primary-700">
                {column.title}
            </Text>
            {column.help && (isHovering || !!isHelpOpen) && (
                <Icon
                    icon={PriorityIcon.help}
                    skin="standart"
                    onClick={e => handleShowColumnHelp(e, column.help)}
                />
            )}
        </div>
    );
};

export default HeaderItem;
